"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var log = exports.log = function log(msg) {
  if (window.ENABLE_LBSSDK_LOG) {
    window.console.log(msg);
  }
};